import './CardNoticias.css'

import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';

const CardNoticias = (props) => {
    return (        
        <div className='row noticia'>
            <div className='col-4 div-imagem-noticia'>
                <img className='imagem-noticia' src={props.imagem}></img>
            </div>
            <div className='col-8 corpo-noticia'>
                <div className='titulo-noticia'>
                    <a href={props.link_botao}>
                        {props.titulo}
                    </a>
                </div>  
                <div className='rodape-noticia'>
                    {props.rodape}
                </div>    
            </div>
        </div>
        /*<!--<Card className='card_noticia' style={{ width: '18rem'}}>
            <Card.Img variant="left" src={props.imagem} />
            <Card.Body>
                <Card.Title>{props.titulo}</Card.Title>
                <Card.Text>
                    {props.texto}
                </Card.Text>
                <Button variant="primary" href={props.link_botao}> {props.titulo_botao}</Button>
            </Card.Body>
            <Card.Footer>
                <small className="text-muted">{props.rodape}</small>
            </Card.Footer>
        </Card>-->*/
    )
}

export default CardNoticias